// src/components/TextInspectionModal/HistoryTextInspectionPanel.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, IconButton, CircularProgress } from '@mui/material';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import { useDynamicTranslation } from './useDynamicTranslation';
import './HistoryTextInspectionPanel.css';

const ReasonBox = ({ reason, severity }) => {
    const { t } = useTranslation();
    const { textToShow, isTranslating, needsTranslation, handleTranslate } = useDynamicTranslation(reason);
    
    const reasonLabel = severity 
        ? t('textInspection.reasonLabel', { severity: severity })
        : t('textInspection.reasonLabelNoSeverity');
    
    return (
        <div className="quote-reason-box">
            <div className="reason-header">
                {needsTranslation && (
                     <Tooltip title={t('textHighlighter.tooltip.translateReason')} placement="top">
                        <IconButton size="small" onClick={handleTranslate} disabled={isTranslating} className="translate-reason-button">
                             {isTranslating ? <CircularProgress size={14} /> : <GTranslateIcon sx={{ fontSize: 16 }} />}
                        </IconButton>
                    </Tooltip>
                )}
                <div className="reason-label-wrapper">
                  <span className="reason-label">{reasonLabel}:</span>
                </div>
            </div>
            <p className="reason-text">{textToShow}</p>
        </div>
    );
};

const HistoryTextInspectionPanel = ({ regions }) => {
    return (
        <div className="text-panel-container">
            {regions.map((region, index) => {

                return (
                    <div key={index} className="quote-card">
                        <p className="quote-text">"{region.quote}"</p>
                        <ReasonBox reason={region.reason} severity={region.severity} />
                    </div>
                );
            })}
        </div>
    );
};

export default HistoryTextInspectionPanel;